module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/login/definicao-senha/definicao-senha.component.scss
// module id = ./src/app/login/definicao-senha/definicao-senha.component.scss
// module chunks = main